import React, { useMemo } from 'react';

import { useFlags } from 'launchdarkly-react-client-sdk';

import { CardsContainer } from './CardsContainer';
import { LiteratureDownloadablesWrapper } from './styled';
import { LiteratureRelatedContent } from '../LiteratureRelatedContent/LiteratureRelatedContent';
import { OwnersLiteratureDocumentsData } from '../../typings/general';
import { splitDocumentsByType } from '../../utils/general';
import { useMaintenanceContext } from '../../hooks/use-maintenance-context';

export const LiteratureDownloadables = ({
  literatureData,
  apiConfig,
  setLiteratureData
}: {
  literatureData: OwnersLiteratureDocumentsData[];
  apiConfig: string;
  setLiteratureData: (value: any) => void;
}) => {
  const { maintenanceFaHideRelatedContent } = useFlags();
  const { translationHandler } = useMaintenanceContext();
  const { warrantyDocuments, additionalResourcesDocuments } = useMemo(() => {
    return splitDocumentsByType(literatureData);
  }, [literatureData]);

  return (
    <LiteratureDownloadablesWrapper>
      <CardsContainer
        title={translationHandler('literature.downloadables.titleSection')}
        subTitle={translationHandler('literature.downloadables.subTitleWarrantySection')}
        documentsData={warrantyDocuments}
        apiConfig={apiConfig}
      />
      <CardsContainer
        title={translationHandler('literature.downloadables.titleSection')}
        subTitle={translationHandler('literature.downloadables.subTitleResourcesSection')}
        documentsData={additionalResourcesDocuments}
        type='resources'
        apiConfig={apiConfig}
      />
      {!maintenanceFaHideRelatedContent && <LiteratureRelatedContent setLiteratureData={setLiteratureData} apiConfig={apiConfig} />}
    </LiteratureDownloadablesWrapper>
  );
};
